import React, { useState, useRef, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { history } from "../../../../../_helpers";
import Button from "../../../../Utils/Button/index";
import { Link } from "react-router-dom";
import MyReportsIcon from "../../../../../images/new-images/myreports.png";
import InstrumentIcon from "../../../../../images/instrument.svg";
import NewDateRangePicker from "../../../../../_components/common/NewDateRangePicker";
import axios from "axios";
import addAccessTokenToUrl from "../../../../Utils/Axios/addTokenToUrl";
import { useMobileStatus } from "../../../../Utils/useMobileStatus";
var moment = require("moment");

var moment = require("moment");

const AssessmentFilter = () => {

  useEffect(() => {
    localStorage.removeItem('selectedAssessmentIds');
  }, []);
  



  const RelationOptions = [
  
    "360-Degree Feedback",
    "Collaborative Style",
    "Execution Style",
    "Leadership Style",
    "Overall Social Style",
  ];
  const [OrientationOptions, setOrientationOptions] = useState([]);

  const [isDatePickerClicked, setIsDatePickerClicked] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState("");
  const [orientationDropdownOpen, setOrientationDropdownOpen] = useState(false);
  const [relationDropdownOpen, setRelationDropdownOpen] = useState(false);
  const [instrumentDropdownOpen, setInstrumentDropdownOpen] = useState(false);
  const [selectedOrientation, setSelectedOrientation] = useState([]);
  const [selectedRelation, setSelectedRelation] = useState("");


  const isMobile = useMobileStatus();


  const [endStatus , setEndStatus] = useState(false)
  const [startStatus, setStartStatus] = useState(false)

  const handleDatePickerClick = () => {
    setIsDatePickerClicked(true);
  };


  const toggleOrientationDropdown = () => {
    setOrientationDropdownOpen(!orientationDropdownOpen);
  };
  const toggleRelationDropdown = () => {
    setRelationDropdownOpen(!relationDropdownOpen);
  };
  const toggleInstrumentDropdown = () => {
    setInstrumentDropdownOpen(!instrumentDropdownOpen);
  };

  const handleOrientationCheckboxChange = (value) => {
    const updatedOrientation = selectedOrientation.includes(value)
      ? selectedOrientation.filter((option) => option !== value)
      : [...selectedOrientation, value];

    setFormData((prevFormData) => ({
      ...prevFormData,
      orientation: updatedOrientation,
    }));
    setOrientationDropdownOpen(true);
    setSelectedOrientation(updatedOrientation);
  };

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);



  const resetValidation = () => {
    const errors = {
      date: "",
      instrument: "",
    };
    setValidationErrors(errors);
  };

  const [formData, setFormData] = useState({
    dateRangeValue: { startDate: null, endDate: null },
    dropdown2: "",
    orientation: [],
    relation: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    date: "",
    instrument: "",
  });

  const handleDateRangeChange = (range) => {

    if(range.start_date !== null){
      if(range.start_date.length === 0){
      
          setStartStatus(true)
        }else{
   
          setStartStatus(false)
        }
    }
    if(range.end_date !== null){
        if(range.end_date.length === 0){
       
          setEndStatus(true)
        }else{
     
          setEndStatus(false)
        }
    }
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      dateRangeValue: {
        startDate: moment(range.start_date).format("DD/MM/YYYY"),
        endDate: moment(range.end_date).format("DD/MM/YYYY"),
      },
    }));
    resetValidation();
  };

  const handleDropdownChange = (value) => {

    setFormData((prevFormData) => ({
      ...prevFormData,
      dropdown2: value,
      relation: value === "LOI 360" ? "360-Degree Feedback" : selectedRelation,
      orientation:
        value === "LOI 360"
          ? [
            "Relationship",
            "Leadership",
            "Achievement",
            "Nurturing",
            "Learning",
          ]
          : [
            "Relationship",
            "Leadership",
            "Achievement",
            "Nurturing",
            "Learning",
          ],
    }));
    setSelectedOption2(value);
    if (value === "LOI 360") {
      setSelectedRelation("360-Degree Feedback");
      setSelectedOrientation([
        "Relationship",
        "Leadership",
        "Achievement",
        "Nurturing",
        "Learning",
      ]);
    }
    if (value === "LOI Self") {

      setSelectedOrientation([
        "Relationship",
        "Leadership",
        "Achievement",
        "Nurturing",
        "Learning",
      ]);
      setSelectedRelation("");
    }
    resetValidation();
  };

  const handleRelationCheckboxChange = (option) => {
    setSelectedRelation(option);

    setFormData((prevFormData) => ({
      ...prevFormData,
      orientation: prevFormData.orientation.includes(option)
        ? prevFormData.orientation.filter((o) => o !== option)
        : [...prevFormData.orientation],
      relation: option,
    }));
  };

  const parseDate = (dateString) => {
    var parts = dateString.split('/');
    // Note: months are 0-based in JavaScript Date object
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }


  const handleFormSubmit = (e) => {
    e.preventDefault();
    const { dateRangeValue, dropdown2 } = formData;





    // Create two Date objects
    var date1 = parseDate(dateRangeValue.startDate);
    var date2 = parseDate(dateRangeValue.endDate);

 

    // Get the difference in milliseconds
    var differenceMs = date2.getTime() - date1.getTime();

    // Convert milliseconds to days
    var differenceDays = differenceMs / (1000 * 3600 * 24);


    let isValid = true;
    const errors = {
      date: "",
      instrument: "",
    };
    if (dateRangeValue.startDate === 'Invalid date' && dateRangeValue.endDate === 'Invalid date') {
      isValid = false;
      errors.date = "Please select a date range.";
    }
    if (dateRangeValue.startDate !== 'Invalid date' && dateRangeValue.endDate === 'Invalid date') {
      isValid = false;
      setEndStatus(true)
    }
    if (dateRangeValue.startDate === 'Invalid date' && dateRangeValue.endDate !== 'Invalid date') {
      isValid = false;
       setStartStatus(true)
    }
    if (differenceDays < 0) {
      isValid = false;
      errors.date = "End date should be greater then start date";
    }
    if (!dateRangeValue.startDate || !dateRangeValue.endDate || dateRangeValue.startDate === undefined || dateRangeValue.endDate === undefined) {
      isValid = false;
      errors.date = "Please select a date range.";
    }
    if (!dropdown2) {
      isValid = false;
      errors.instrument = "Please select an instrument.";
    }

    setValidationErrors(errors);



    if (isValid) {
      localStorage.setItem("filterData", JSON.stringify({ formData }));
      history.push("/new/app/assessment");
    }
  };

  useEffect(() => {
    orientationList()
      .then((response) => {
        const options = response.data.response.map(
          (item) => item.orientation__orientation_name
        );
   
        setOrientationOptions(options);
      })
      .catch((error) => {
        console.error("Error fetching orientation list:", error);
      });
  }, []);

  function orientationList() {
    const data = {
      instrument_id: 9,
    };
    return axios.post(
      addAccessTokenToUrl("/masters/instrument/orientation/list/"),
      data
    );
  }



  return (
    <div>
      <Form onSubmit={handleFormSubmit}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            paddingBottom: "20px",
            flexWrap: "wrap",
            
          }}
        >
          <FormGroup>
            <Label for="dropdown1" style={{ color: "grey" }}>
              Select Date
              <span style={{ color: "red" }}>*</span>
            </Label>
            <div
              onClick={handleDatePickerClick}
              style={{ width: isMobile?"370px" :"400px", height: "50px", background: "white" }}
            >
          
              <NewDateRangePicker startStatus ={startStatus} endStatus={endStatus} key={"compare_assessment"} onDateRangeChange={handleDateRangeChange}   shouldResetOnLocationChange={true}  />
            </div>
            {validationErrors.date && (
              <span style={{ color: "red",position: isMobile ? "relative" : "static",
              top: isMobile ? "30px" : "auto",
           }}>{validationErrors.date}</span>
            )}
          </FormGroup>

          <FormGroup style={{paddingTop:isMobile?'20px':'0px'}}>
            <Label for="dropdown2" style={{ color: "grey" }}>
              Select Instrument
              <span style={{ color: "red" }}>*</span>
            </Label>

            <ButtonDropdown
              isOpen={instrumentDropdownOpen}
              toggle={toggleInstrumentDropdown}
              style={{ width: isMobile?"370px" :"400px", height: "50px", background: "white" }}
            >
              <DropdownToggle
                onClick={toggleInstrumentDropdown}
                className="d-flex justify-content-between align-items-center"
                style={{
                  background: "white",
                  color: "black",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  border: "1px solid #dbdbdb",
                }}
              >
                {selectedOption2 ? (
                  selectedOption2
                ) : (
                  <div>
                    <img src={InstrumentIcon} alt="#" /> Select Instrument
                  </div>
                )}
                <i className="fa fa-chevron-down" aria-hidden="true" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  style={{
                    width: "400px",
                    height: "50px",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "40px",
                  }}
                  onClick={() => handleDropdownChange("LOI Self")}
                >
                  LOI Self
                </DropdownItem>
                <hr />
                <DropdownItem
                  style={{
                    width: "400px",
                    height: "50px",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "40px",
                  }}
                  onClick={() => handleDropdownChange("LOI 360")}
                >
                  LOI 360
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
            {validationErrors.instrument && (
              <span style={{ color: "red"}}>
                {validationErrors.instrument}
              </span>
            )}
          </FormGroup>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            paddingBottom: "20px",
            flexWrap: "wrap",
          }}
        >
          <FormGroup>
            <Label for="dropdown2" style={{ color: "grey" }}>
              Select Orientation
            </Label>
            <ButtonDropdown
              style={{ width: isMobile?"370px" :"400px", height: "50px", background: "white" }}
              isOpen={orientationDropdownOpen}
              toggle={toggleOrientationDropdown}
            >
              <DropdownToggle
                onClick={toggleOrientationDropdown}
                className="d-flex justify-content-between align-items-center"
                style={{
                  background: "white",
                  color: "black",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  border: "1px solid #dbdbdb",
                }}
              >
                {selectedOrientation.length === 0 ? (
                  <div>
                    <img src={MyReportsIcon} alt="#" /> Select Orientation
                  </div>
                ) : selectedOrientation.length === OrientationOptions.length ? (
                  "All"
                ) : (
                  <span>{selectedOrientation.join(", ")}</span>
                )}
                <i className="fa fa-chevron-down" aria-hidden="true" />
              </DropdownToggle>

              <DropdownMenu>
                {OrientationOptions.map((option, index) => (
                  <div>
                    <DropdownItem
                      style={{
                        width: "400px",
                        height: "30px",
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "40px",
                      }}
                      onClick={() => handleOrientationCheckboxChange(option)}
                    >
                      <Label check>
                        <Input
                          type="checkbox"
                          value={option}
                          checked={selectedOrientation.includes(option)}
                          onChange={() =>
                            handleOrientationCheckboxChange(option)
                          }
                        />
                        {option}
                      </Label>
                    </DropdownItem>
                    {index < OrientationOptions.length - 1 && <hr />}
                  </div>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
          <FormGroup>
            <Label for="dropdown2" style={{ color: "grey" }}>
              Select Report Type
            </Label>
            <ButtonDropdown
              style={{
                width: isMobile?"370px" :"400px",
                height: "50px",
                background: "white",
                opacity: selectedOption2 === "LOI 360" ? 1 : 0.5,
              }}
              isOpen={relationDropdownOpen}
              disabled={selectedOption2 !== "LOI 360"}
              toggle={toggleRelationDropdown}
            >
              <DropdownToggle
                onClick={toggleRelationDropdown}
                className="d-flex justify-content-between align-items-center"
                style={{
                  background: "white",
                  color: "black",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  border: "1px solid #dbdbdb",
                }}
              >
                {selectedRelation ? (
                  selectedRelation
                ) : (
                  <div>
                    <img src={InstrumentIcon} alt="#" /> Select Report Type
                  </div>
                )}
                <i className="fa fa-chevron-down" aria-hidden="true" />
              </DropdownToggle>
              <DropdownMenu>
                {RelationOptions.map((option, index) => (
                  <div>
                    <DropdownItem
                      style={{
                        width: "400px",
                        height: "30px",
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "40px",
                      }}
                      onClick={() => handleRelationCheckboxChange(option)}
                    >
                      {option}
                    </DropdownItem>
                    {index < RelationOptions.length - 1 && <hr />}
                  </div>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
        </div>

   

        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <Link to="/new/app/reports/:id">
            <Button style={{ height: "60px", width: "150px" }} type="back">
              BACK
            </Button>
          </Link>

          <Button style={startStatus && endStatus ? {backgroundColor : 'lightgrey' , border: '1px solid lightgrey', height: "60px", width: "150px"} : { height: "60px", width: "150px"}} type="submit" disabled={startStatus && endStatus ? true : false}>
            CONTINUE
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AssessmentFilter;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/CompareAssessment/AssessmentFilter/index.jsx